const listKeys = (_options?: {
  cssClass?: string,
  titleClass?: string,
}) => {
  const opt = {
    cssClass: '.ListKeyPoints',
    titleClass: '.TeaserKeyfigure-highlight',
    ..._options
  };
  const target: string = `${opt.cssClass}-list`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClass}`]) {
      return true; // already init go to next iteration
    }

    // Set Height of Max ListKey title
    const listKeyTitle: any = elt.querySelectorAll(`${opt.titleClass}`);
    let maxHeightTitle = -1;

   window.addEventListener('load', () => {
      calculateHeightSize();
      adaptHeightSize();
    });

    window.addEventListener('resize', () => {
      maxHeightTitle = -1;
      calculateHeightSize();
      adaptHeightSize();
    });

    function calculateHeightSize() {
      for (const item of listKeyTitle) {
        item.style.removeProperty('height');
        maxHeightTitle = maxHeightTitle > item.offsetHeight ? maxHeightTitle : item.offsetHeight;
      }
    }

    function adaptHeightSize() {
      for (const item of listKeyTitle) {
        item.style.height = maxHeightTitle + 'px';
      }
    }
  }
};

export default listKeys;
